import { useSelector } from 'react-redux';

import { componentSeasonSelectors } from '../componentSeason';

const getSeasonByType = (seasonType) => {
    const currentSeason = componentSeasonSelectors(seasonType).season;
    const { seasons } = useSelector(({ seasons }) => seasons.seasonsState);
    return seasons.find((season) => season.id === currentSeason);
}

export default getSeasonByType;
